import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  ocultarFooter: boolean = false;

  /** Rutas internas (software administrativo) donde no mostramos el footer. */
  private readonly RUTAS_SIN_FOOTER = [
    '/autorizaciones-listado',
    '/usuarios-listado',
    '/usuario-modificacion',
    '/configurar-administracion',
    '/estadisticas-sistema',
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Evaluamos también al iniciar: al recargar la página, el NavigationEnd
    // inicial puede llegar antes de que nos suscribamos.
    this.ocultarFooter = this.esRutaSinFooter(this.router.url);

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.ocultarFooter = this.esRutaSinFooter(e.urlAfterRedirects || e.url);
      });
  }

  private esRutaSinFooter(url: string): boolean {
    return this.RUTAS_SIN_FOOTER.some((ruta) => (url || '').startsWith(ruta));
  }

}
